(function () {
  const root = document.querySelector('[data-product-complementary-root]');
  if (!root) return;

  const productId = root.dataset.productId;
  const baseUrl = root.dataset.url;
  const sectionId = root.dataset.sectionId;
  const addedText = root.dataset.addedText || 'Added';
  const addingText = root.dataset.addingText || 'Adding...';
  const errorText = root.dataset.errorText || 'Error';
  const limit = 4;

  if (!productId || !baseUrl || !sectionId) return;

  async function fetchRecommendations() {
    try {
      // Add timestamp to prevent caching
      const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&intent=complementary&limit=${limit}&t=${Date.now()}`;

      const res = await fetch(url);
      if (!res.ok) return;

      const text = await res.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const items = html.querySelector('[data-product-complementary-items]');
      const listContainer = root.querySelector('[data-complementary-list]');

      if (items && items.children.length > 0 && listContainer) {
        listContainer.innerHTML = items.innerHTML;
        root.style.display = 'block';
        initButtons(listContainer);
      } else {
        root.style.display = 'none';
      }
    } catch (e) {
      console.error('Error fetching complementary products:', e);
    }
  }

  function initButtons(container) {
    const buttons = container.querySelectorAll('[data-upsell-btn]');
    buttons.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const item = btn.closest('.product__info__upsell__item');
        const variantId = item.dataset.upsellVariantId;
        const img = item.querySelector('img.product__info__upsell__item__img');
        const thumbUrl =
          (img && (img.currentSrc || img.getAttribute('src'))) || '';

        if (variantId) {
          addToCart(variantId, btn, thumbUrl);
        }
      });
    });
  }

  // "Adding..." shows for at least this long from the click, so on a fast connection the cart panel still
  // reads as a response to the click rather than snapping open. On a typical connection the add and cart
  // requests (~1.2 s together) already take longer than this and no extra wait is added.
  const MIN_ADDING_MS = 500;
  // In notification mode the button reads "Added" for this long before going back to "Add to cart".
  const ADDED_MS = 1200;
  const ERROR_MS = 2000;

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function restoreButton(btn, text) {
    if (!btn || !btn.isConnected) return;
    btn.disabled = false;
    btn.textContent = text;
  }

  async function addToCart(variantId, btn, thumbUrl) {
    const startedAt = Date.now();
    const originalText = btn.textContent;
    if (btn.dataset && !btn.dataset.mmOriginalText) {
      btn.dataset.mmOriginalText = originalText;
    }
    btn.disabled = true;
    btn.textContent = addingText;

    try {
      const imageStore =
        window.MegaMacCart &&
        window.MegaMacCart.cartImageStore &&
        typeof window.MegaMacCart.cartImageStore.set === 'function'
          ? window.MegaMacCart.cartImageStore
          : window.MegaMacCart &&
              window.MegaMacCart.hoverImageStore &&
              typeof window.MegaMacCart.hoverImageStore.set === 'function'
            ? window.MegaMacCart.hoverImageStore
            : null;
      if (imageStore && thumbUrl) imageStore.set(variantId, thumbUrl);
    } catch (_) {}

    const sendAdd = function () {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });
    };

    let addedItem;
    try {
      // Through the theme-wide queue (layout/theme.liquid), so it can't overlap a cart change from the
      // header cart panel; Shopify would lose one of them.
      const response = await (window.MegaMacCart &&
      typeof window.MegaMacCart.queueCartRequest === 'function'
        ? window.MegaMacCart.queueCartRequest(sendAdd)
        : sendAdd());
      if (!response.ok) throw new Error('Failed to add to cart');
      addedItem = await response.json();
    } catch (error) {
      console.error(error);
      btn.textContent = errorText;
      await wait(ERROR_MS);
      restoreButton(btn, originalText);
      return;
    }

    const feedbackMode =
      (window.MegaMacCart &&
        window.MegaMacCart.addToCartFeedbackMode &&
        window.MegaMacCart.addToCartFeedbackMode()) ||
      'drawer';

    if (feedbackMode === 'cart_page') {
      window.location.href = window.MegaMacCart.cartUrl || '/cart';
      return;
    }

    // One cart read, shared with the header cart panel through the event below (it would otherwise read
    // the cart again itself before opening).
    let cart = null;
    try {
      if (window.MegaMacCart && typeof window.MegaMacCart.fetchCartAndEmit === 'function') {
        cart = (await window.MegaMacCart.fetchCartAndEmit()) || null;
      }
    } catch (_) {}

    await wait(Math.max(0, MIN_ADDING_MS - (Date.now() - startedAt)));

    // Opens the cart panel (drawer mode) or shows the toast (notification mode).
    if (window.MegaMacCart && typeof window.MegaMacCart.emitCartAdded === 'function') {
      window.MegaMacCart.emitCartAdded(cart, addedItem, 1, 'add', thumbUrl);
    }

    // Keep existing hook for any other listeners.
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { source: 'product-complementary' },
      }),
    );

    if (feedbackMode === 'notification') {
      btn.textContent = addedText;
      await wait(ADDED_MS);
    }
    restoreButton(btn, originalText);
  }

  // Initialize
  fetchRecommendations();

  function restoreAddButtonLabel() {
    if (!root) return;
    const buttons = root.querySelectorAll('[data-upsell-btn]');
    if (!buttons || !buttons.length) return;

    buttons.forEach(function restoreOne(btn) {
      if (!btn) return;
      const original = (btn.dataset && btn.dataset.mmOriginalText) || '';
      if (!original) return;
      btn.textContent = original;
      btn.disabled = false;
      try {
        delete btn.dataset.mmOriginalText;
      } catch (_) {}
    });
  }

  // Re-fetch on pageshow (back/forward cache). Always restore Adding labels:
  // some browsers restore the mutated DOM after POST-redirect without persisted.
  window.addEventListener('pageshow', function restoreAddButtonLabelOnShow(event) {
    restoreAddButtonLabel();
    if (event.persisted) {
      fetchRecommendations();
    }
  });

  // Listen for cart updates from other sources
  document.addEventListener('cart:refresh', event => {
    if (
      event &&
      event.detail &&
      event.detail.source === 'product-complementary'
    )
      return;
    fetchRecommendations();
  });
  document.addEventListener('cart:updated', fetchRecommendations);
})();
